import { Component, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
	faPen,
	faTrashAlt,
	faPlusCircle,
	faFileExcel,
	faBookmark,
} from '@fortawesome/free-solid-svg-icons'

import { format } from 'fecha'
import fetch from '@/helpers/fetch'

import Loader from '@/components/Loader/index.vue'
import MessageSuccess from '@/components/edit/MessageSuccess/index.vue'

library.add(faPen, faTrashAlt, faPlusCircle, faFileExcel, faBookmark)

@Component({
	components: {
		Loader,
		MessageSuccess,
	},
})
export default class Users extends Vue {
	currentPage = 1
	perPage = 20
	totalUsers = 0
	usersList = []
	fields = [
		{
			key: 'select',
			label: '',
		},
		{
			key: 'id',
			label: 'ID',
		},
		{
			key: 'name',
			label: 'Nome',
		},
		{
			key: 'email',
			label: 'Email',
		},
		{
			key: 'actions',
			label: 'Ações',
		},
	]

	filters = {
		name: '',
	}

	options = {
		page: [10, 20, 30, 40, 50],
	}

	getQueryParams(): string[] {
		let params: string[] = []

		if (this.filters.name) params.push('name=' + this.filters.name)

		return params
	}

	async loadUsers() {
		const res = await fetch.get('/api/users')
		this.totalUsers = res.data.length
		this.usersList = res.ok ? res.data : []
	}

	async usersProvider(ctx) {
		let params = this.getQueryParams()
		//params.push('page=' + ctx.currentPage, 'items=' + ctx.perPage);

		const query = params.join('&')
		const res = await fetch.get('/api/users?' + query)
		this.totalUsers = res.data.length

		return res.ok ? res.data : []
	}

	userToDelete: any | null = null
	async onDelete(user) {
		this.userToDelete = user
		this.$bvModal.show('modal-delete')
	}

	deleting = false
	deleteSuccess = false
	async onDeleteConfirm() {
		this.deleting = true
		if (this.userToDelete) {
			this.deleteSuccess = false
			const res = await fetch.delete('/api/users/' + this.userToDelete.id)

			if (res.ok) {
				this.deleteSuccess = true
				this.$root.$emit('bv::refresh::table', 'users-table')
			}
		}
		this.deleting = false
	}

	close() {
		this.deleting = false
		this.deleteSuccess = false
		this.userToDelete = null
		this.$bvModal.hide('modal-delete')
	}

	/*
	updateTable() {
		// @ts-ignore
		this.$refs.usersTable.refresh();
		this.getItemsCount();
	}

	@Watch('filters.name')
	searchName() {
		this.updateTable();
	}
	*/

	mounted() {
		//this.loadUsers();
	}
}
